import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TeamsCard from "../../utils/teams_card";
import plusImage from "../../assets/plus.png";

export default function DashTeams() {
  const { user } = useSelector((state) => state.user);
  const [teams, setTeams] = useState([]);
  const [displayedTeams, setDisplayedTeams] = useState(10);

  const handleShowMore = () => {
    setDisplayedTeams((prevDisplayed) => prevDisplayed + 1);
  };

  const handleCreateRoster = (teamId) => {
    window.location.href = `/create-roster-form?teamId=${teamId}`;
  };

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await fetch(
          `https://server-postgre.vercel.app/get-user-teams`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ user_id: user.id }),
          }
        );
        const data = await response.json();
        setTeams(data);
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };

    fetchTeams();
  }, [user.id]);

  return (
    <div className="flex " style={{ maxHeight: "245px" }}>
      {teams.slice(0, displayedTeams).map((team) => (
        <div
          key={team.id}
          className="block mx-2 text-center bg-gradient-to-b from-white to-gray-200 rounded-lg p-8"
        >
          <a href={`/dashboard?tab=rosters`}>
            <TeamsCard
              image={`https://server-postgre.vercel.app/${team.photo_url}`}
              name={team.name}
            />
          </a>
          <button
            onClick={() => handleCreateRoster(team.id)}
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-2"
          >
            Create Roster
          </button>
        </div>
      ))}
      <a
        href="/create-team"
        className="block mx-2 text-center bg-gradient-to-b from-white to-gray-200 rounded-lg p-8"
      >
        <TeamsCard image={plusImage} name="Crear Equipo" />
      </a>
      {teams.length > displayedTeams && (
        <button
          onClick={handleShowMore}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-2"
        >
          Show 1 more
        </button>
      )}
    </div>
  );
}
